import ProjectData from '@/data/ProjectData.ts'

export default [
  new ProjectData("project-1", "Luca", "img/projects/luca-icon.gif",
    `
    <div class="paragraph">
     This <strong> Luca</strong> game for the Happy Meal App, <strong>based on the PIXAR animated film</strong>, is one of my most polished Unity mini-games ever. 
     <strong>Goal:</strong> Scour the town to find parts for your makeshift bike&#8212;like in the movie! 
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/wc6MXX7R824?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    

    
    <hr>
    <div class="paragraph">
        Responsibilities & Features :
        <ul>
        <li>Gameplay programming</li>
        <li>Level Design including sketches and grayboxing out a riviera fishing village similar to the film's</li>
        <li>Final optimized design of all buildings, streets, props, boats, and vehicles</li>
        <li>Programmed a minimap</li>
        <li>Liaising with licensing team at Pixar on all movie lore and visual fidelity of assets</li>
        <li>Character mesh polyreduction, UVs, and texturing</li>
        <li>Rigging, animation, and locomotion</li>
        <li>Integration into larger core app</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/luca4.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/luca7.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/luca2.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/luca3.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/luca5.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/luca8.png" alt="Luca Bike Parts Hunt Screenshot" />
        
    </div>
    <div class="paragraph center">
        <strong>Note: </strong>Happy Meal App has been discontinued by McDonalds.
    </div>
    `, "#bf9000", true, true),
  new ProjectData("project-2", "Frozen 2", "img/projects/frozen2-icon.gif", `
    <div class="paragraph">
     As you can imagine, <strong> Frozen 2</strong> was one of the most popular IPs for the Happy Meal App. <strong>Based on the Walt Disney Studios film, </strong> this Ring of Fire game was exciting to work on.<br><br>
     <strong>Objective:</strong> Rotate your device to repel the Fire sprite and protect Elsa and Olaf! 
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/5-Ap2JlX7Nk?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    
    <hr>
    <div class="paragraph">
        Responsibilities & Features :
        <ul>
        <li>Gameplay programming</li>
        <li>Localization via Google Sheets to support multiple languages</li>
        <li>Level Design</li>
        <li>Liaising with art team at Disney on all movie lore and visual detail. For example, I had to implement and emphasize Olaf's animated <strong>permafrost</strong> texture (see below)</li>
        <li>Character mesh polyreduction, UVs, and texturing</li>
        <li>Rigging, animation, and locomotion</li>
        <li>Integration into larger core app</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/frozen2-1.png" alt="Frozen 2 Ring of Fire Screenshot" />
        <img class="pc-screenshot" src="img/projects/frozen2-3.png" alt="Frozen 2 Ring of Fire Screenshot" />
        <img class="pc-screenshot" src="img/projects/frozen2-4.png" alt="Frozen 2 Ring of Fire Screenshot" />
    </div>
    `, "#5a78af", false, false),
  new ProjectData("project-3", "Other McDonalds Games", "img/projects/sw-forcepush-icon.png", `
<div class="paragraph">

    <div class="hc-title">Star Wars: ROS - Force Push Training</div>

    My eldest still brags to her friends that I worked on McDonalds games. All these games were nested within a larger custom Unity platform, took anywhere from 4-8 weeks to produce, were snackable (only a few minutes of gameplay), and were only live for 4-6 weeks, depending on the Happy Meal window.<br>
    </div>

    <div class="paragraph">
    I'm also a strong <strong> Technical Artist</strong>. Here's the <strong>SandCrawler</strong> and <strong>SandTrooper</strong> defense game I did all the programming, environment design, rigging, animation, art and textures for&#8212;using Unity and Maya.
    </div>
    
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/5ILNB3qq3MQ?rel=0" frameborder="0" allowfullscreen></iframe>
    </div><br>
      </div>
      
      <div style="clear:both"></div>
    </div>

<hr>

<div class="hc-title">Be an Inventor: Pokemon Portal Rescue</div>

    Who doesn't love Pokemon? A huge portion of our user base consisted of families with Happy Meal-aged children, so I occasionally had the privilege of developing games with STEM-based learning elements. In this 2D Physics Sandbox game, for example, users built a ramp using various shapes to launch Dialga through a portal to rescue Palkia.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/Tr-qCwxsb9M?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <br>
<hr>

<div class="paragraph">
    <div class="hc-title">Littlest Pet Shop Pairs</div>

    Of course, I got to work with other toy licensors as well, such as Hasbro. Their partnership with McDonalds gave me the opportunity to develop several Littlest Pet Shop games. In this game, written in Lua and Corona SDK, I programmed both a 1-Player and 2-Player modes. The first player to match 10 pairs wins!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/qNGimQJbXDQ?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    Help Minka be the first one to clicking on ten matching pairs!<br>
    <ul>
    <li>Built using Corona SDK and Lua programming</li>
    <li>1 and 2 Player Modes (local multiplayer)</li> 
    <li>Dozens of custom art sprites created </li>
    <li>6 total LPS characters and themes</li>
    <li>Cross-platform and maximum device reach</li>
    <li>Most-popular McPlay game despite its limited Live window in 2014, according to metrics</li>
</ul>
    

<div class="paragraph">
      <a href="apk/LPS_Minka.apk">
      Download apk
      </a>
    </div>
    </div>
    
    <div style="clear:both"></div>
  </div>

<hr>



    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/08diOxHhHHs?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Onward - Road Trip</div>
      Help Barley Lightfoot drive Guinevere the Van to a destination before time runs out!<br>
      <br>
      Be careful not to hit any obstacles, curbs, or unicorns.<br>
Enjoy the robust, optimized level design!<br>

<div class="paragraph">
        <a href="#">
        Download apk
        </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>

    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/e0PSpwQnQq8?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Pete the Cat - Greeting Card Maker</div>
      Create your own greeting cards in this cool IP from Harper Collins!<br>
      <br>
      Select from several backgrounds, and drag-and-drop stickers to decorate your card.<br>
      Share with your friends!
      <br><br>
      <div>
      <a href="https://www.youtube.com/watch?v=e0PSpwQnQq8" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/gIy8jS5kUS0?rel=0?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Mickey and Minnie's Runaway Railway</div>
      Tilt your device to drive Mickey &amp; Minnie to collect all your fishy friends before time runs out !<br>
      <br>
      Enjoy the amazing underwater scenery in this fun driving game! But be careful, miss just one fish and it's game over!
      <br><br>
      <div>
      <a href="https://www.youtube.com/watch?v=gIy8jS5kUS0" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/hUVru5pPxsU?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Sing 2 - Redshore Run</div>
      It's your shift! Enjoy navigating around scenic Redshore City to pick up this year's talent show contestants and bring them to the audition before time runs out!<br>
      <br>
      <div>
      <a href="https://www.youtube.com/watch?v=hUVru5pPxsU" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/zW75sq1ybVw?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Black Widow Motorcycle Training</div>
      Help Black Widow train her agility and dexterity via this unpredictable obstacle track<br>
      <br>
      <div>
      <a href="https://www.youtube.com/watch?v=zW75sq1ybVw" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/dc-jfBPB9qk?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">DC Heroes - Gotham Ride</div>
      Choose between Batman or Batgirl and cruise around Gotham while avoiding obstacles<br>
      <br>
      <div>
      <a href="https://www.youtube.com/watch?v=dc-jfBPB9qk" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/ywmRAYyeOAM?rel=0" frameborder="0" allowfullscreen=""></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Marvel Heroes - Space Race</div>
      Help Baby Groot navigate the Milano through the asteroid field and wormhole! Collect force field powerups for temporary invincibility.<br>
      <br>
      <div>
      <a href="https://www.youtube.com/watch?v=ywmRAYyeOAM" target="_blank">
      Watch on YouTube
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

  </div>`, "#ed0028"),
  new ProjectData("project-4", "Kabu Pop Party Quest", "img/projects/kabu-icon.png", `
    <div class="paragraph">
     I had so much fun being on the team that built this Unity bubble shooter for Build-A-Bear Workshop, which helped introduce a set of eight entirely new characters called the Kabu line.
     Players could scan their newly-adopted plush, and <strong>unlock that character for use in the game</strong>. 
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/v-H1qfRLxro?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <hr>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/fUnKCBI25-Q?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/kabu-pop-party-quest/id1405980485" target="_blank"><img src="img/projects/app-store-logo.png" alt="Play Store badge" /></a>
    </div>

    <hr>
    <div class="paragraph">
        Responsibilities :
        <ul>
        <li>Smooth character animations using Puppet2D asset and Mecanim</li>
        <li>Toy recognition training using IBM Watson</li>
        <li>Design of the map, divided into 5 different sections</li>
        <li>Splash screen</li>
        <li>QA Build Distribution via AppCenter and Play Store Console</li>
        <li>Publishing to Play Store and iOS App Store</li>
        </ul>
    </div>

    <div class="paragraph">
        Technical aspects covered during development :
        <ul>
        <li>Scriptable objects for character and level design (100 total playable levels)</li>
        <li>Using Unity Profiler to track down and squash performance bottlenecks</li>
        <li>Image and texture optimization for mobile to maximize the amount of supported devices</li>
        <li>Jagged arrays and matrices to create powerups that removed groups of balls using shapes</li>
        <li>Game balancing</li>
        <li>Help drive customer Loyalty program using Daily quests, powerups and multipliers</li>
        </ul>
    </div>

    <div class="paragraph center">   
        <img class="phone-screenshot" src="img/projects/kabu0.png" alt="Kabu Pop Party Quest Screenshot" />
        <img class="phone-screenshot" src="img/projects/kabu1.png" alt="Kabu Pop Party Quest Screenshot" />
    </div>
    `, "#e80fb7", false, false),
  new ProjectData("project-5", "Solar2D (Corona SDK) Games", "img/projects/neonslaught-icon.gif", `
  <div class="paragraph">
  
    <div class="hc-title">Kids Games in Corona SDK</div>

    Corona SDK was the original name for an amazing 2D game development framework now called Solar2D. It was created by ex-developers from Macromedia/Adobe (RIP Carlos Icaza). Despite its 2D limitations, Corona / Solar2D ruled the roost for several years, and its robustness helped us rule the iOS App Store for a couple years. It still has a huge following.<br><br><hr><br>
    
    <div class="hc-title">Littlest Pet Shop Matching Game</div>
    Hasbro's partnership with McDonalds gave me several opportunities to develop games for their Littlest Pet Shop IP. In this game, written in Lua and Corona SDK, I programmed both a 1-Player and 2-Player modes. Help Minka be the first one to clicking on ten matching pairs!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/qNGimQJbXDQ?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <ul>
    <li>Built using Corona SDK and Lua programming</li>
    <li>1 and 2 Player Modes (local multiplayer)</li> 
    <li>Dozens of custom art sprites created </li>
    <li>6 total LPS characters and themes</li>
    <li>Cross-platform and maximum device reach</li>
</ul>
<hr><br>

<div class="hc-title">The Peanuts Movie - Runaway Sled Race</div>
    Corona SDK/Lua endless runner game created to promote The Peanuts Movie (2015)<br>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/zFRC6jRjVV4?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    
    <ul>
    <li>Featuring six total selectable characters, including two duos</li>
    <li>Tap left or right to switch lanes</li>
    <li>Avoid obstacles!</li>
    <li>Collect apples to keep going!</li>
    
</ul>
<div class="paragraph">
      <a href="apk/PeanutsSledRace_final.apk">
      Download apk
      </a>
      </div>
    </div>
    </div>
<hr><br>

<div class="hc-title">Monster Jam - Track Pack</div>
    Monster Jam game created in Corona SDK that features Grave Digger and all your favorite monster trucks, hearkening back to the days of ExciteBike on the first Nintendo NES!<br>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/r3-wyhBD9ck?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    
    <ul>
    <li>Featuring 8 total selectable trucks</li>
    <li>Unique Monster Truck physics</li>
    <li>Build Your Own Tracks, then Save Them! (JSON)</li>
    <li>Most popular McPlay Corona SDK game </li>
</ul>
<hr><br>

<div class="hc-title">Other Solar2D Games</div>
  Here are some other Solar2D/Corona SDK games I built. <br>
  <font style="font-size: 0.7em">Some games have been removed from the store, for these you can get the .apk here but you'll need to <a href="https://www.androidauthority.com/how-to-install-apks-31494/">authorize third party apk installation</a>.</font><br><br>
  </div>

  <div class="paragraph">
    <div class="hc-left">
      <div>
        <iframe class="youtube-hc" src="https://www.youtube.com/embed/z-qEpWq5nro?rel=0" frameborder="0" allowfullscreen=""></iframe>
      </div>
      </div>
    <div class="hc-right">
    <div class="hc-title">Neonslaught</div>
    Tap to rotate the large ring to match the falling one!<br>

Try to beat your high score!<br>
<br>

    </div>
    </div>
    
    <div class="paragraph">
      <a href="#" target="_blank">
        <img class="hc-badge" alt="Get it on Google Play" src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png">
      </a>
    </div>
    <div style="clear:both"></div>
  </div>

<hr>


  <div class="paragraph">
    <div class="hc-left">
      <div>
        <iframe class="youtube-hc" src="https://www.youtube.com/embed/vya1ilIh07Q?rel=0" frameborder="0" allowfullscreen=""></iframe>
      </div>
      
    </div>
    <div class="hc-right">
    <div class="hc-title">Fly Dennis Fly - Hotel T 2</div>
    Corona SDK/Lua endless runner game in the theme of Flappy Bird, created to promote the Hotel Transylvania 2 film.<br>
    <ul>
    <li>Featuring six total selectable characters</li>
    <li>Tap screen to keep flying</li>
    <li>Avoid obstacles as well as hitting the ground!</li>
    <li>Collect items to keep going!</li>
</ul>

    <div class="paragraph">
    <a href="https://www.youtube.com/watch?v=vya1ilIh07Q" target="_blank">
      Watch on YouTube
    </a>
    
    </div>
    </div>
    
    <div style="clear:both"></div>
  </div>

  <hr>

<div class="paragraph">
    <div class="hc-left">
      <div>
        <iframe class="youtube-hc" src="https://www.youtube.com/embed/fsnuerm_ZBI?rel=0" frameborder="0" allowfullscreen=""></iframe>
      </div>
      
    </div>
    <div class="hc-right">
    <div class="hc-title">My Little Pony - Tap-N-Tumble Match Game</div>
    Corona SDK/Lua matching game for your little ones.<br>
    <ul>
    <li>Tap on more matches to increase your time limit</li>
    <li>Play as your favorite MLP character!</li>
    <li>Available for iOS and Android</li>
</ul>

    <div class="paragraph">
    <a href="https://www.youtube.com/watch?v=fsnuerm_ZBI" target="_blank">
      Watch on YouTube
    </a>
    
    </div>
    </div>
    
    <div style="clear:both"></div>
  </div>

  <hr>

  <div class="paragraph">
    <div class="hc-left">
      <div>
        <iframe class="youtube-hc" src="https://www.youtube.com/embed/7PSlPGg_2T0?rel=0" frameborder="0" allowfullscreen=""></iframe>
      </div>
    </div>
    <div class="hc-right">
    <div class="hc-title">Coca-Cola Cool Kicks</div>
    We developed this game in partnership with the NFL and McDonalds. Kick the football through the uprights!<br>
    <ul>
    <li>Watch the wind direction and speed</li>
    <li>Press KICK When the arrow points in the direction you want to kick</li>
    <li>5 misses ends the game</li>
    <li>3 good kicks adds an extra try!</li>
</ul>

<div class="paragraph">
    <a href="apk/CocaColaCoolKicks.apk">
    Download apk
    </a>
    </div>
    </div>
    
    <div style="clear:both"></div>
  
  </div>`, "#64277a", true, false),

  new ProjectData("project-5", "Suit Up with Spider-Man (AR)", "img/projects/spidey-icon.gif", `
    <div class="paragraph">
     During my time at Creata, we partnered with Kellogg's (now called Kellanova) to create this unique<strong> AR </strong> endless [runner] mobile game. Using Vuforia image tracking of a licensed printed Spider-Man <strong>(Spidey Sensor)</strong>, players used this cutout to move an onscreen reticle like a <strong> joystick</strong> to swing Spidey through New York, London, and Venice. "How?" you ask. See for yourself below with this video from an independent reviewer. 
     <br>
     
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/0HwnzLER3xk?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    The results were <strong>astounding</strong>&#8212;almost 680K total installs across iOS and Android in the nine months the program ran, making it Kellogg's second-most downloaded app <strong>ever</strong>. We endeared ourselves to our long time client by adding value to printed cardboard inserts (found in Frosted Flakes, Pop Tarts, Eggos, etc.)
    </div>
    <div class="paragraph">
        Individual Contributions & Features :
        <ul>
        <li>Game Concept</li>
        <li>Helped with main game loop</li>
        <li>Main point of contact with Vuforia rep for licensing</li>
        <li>Training Vuforia Image Target databases</li>
        <li>Splash screen</li>
        <li>Pedestrians and traffic</li>
        <li>New High Score feature</li>
        <li>QA build distrubution</li>
        <li>Publishing on App Store and Google Play</li>
        </ul>
    </div>
    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/spiderman3.png" alt="Suit Up with Spidey Screenshot" />
        <img class="phone-screenshot" src="img/projects/spiderman4.png" alt="Suit Up with Spidey Screenshot" />
    </div>
  
    <div class="paragraph">
        Some technical aspects covered include:
        <ul>
        <li>Vuforia Image Target tracking</li>
        <li>Unity Profiler to identify performance bottlenecks on lower-power mobile devices</li>
        <li>App optimization via polycount reduction and Power of Two textures</li>
        <li>Creating traffic and pedestrians using particle effects</li>
        <li>Procedurally-generated city blocks</li>
        <li>Curved World shader</li>
        </ul>
    </div>
    <hr>
    <div class="hc-title">Concepts</div>
    <div class="paragraph">
        After a team brainstorming meeting fueled by pizza and pop, <strong><a href="https://www.linkedin.com/feed/update/urn:li:activity:6524050312926416896" target="_blank">I came up with the idea</a></strong>, prototyped a few proofs of concept, and ended up winning us the project from Kelloggs among all other competing agencies. While super even-keel, make no mistake; I'll always have that ad agency competitor bug in me.
    </div>
    
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/fwAV8VOXIKM?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/V20bx-TJ3Gs?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
        <strong>Note:</strong> This app only ran from March to December 2019. I still see some .apks of it available in the wild, but advise against downloading any of those.
    </div>
    `, "#0008ff", true, false),
  new ProjectData("project-5", "Sing 2", "img/projects/sing2-icon.png", `
    <div class="paragraph">
     I developed this top-down driving game in Unity based on the movie <strong> Sing 2</strong>. It is the largest level I've ever designed from scratch. The target look and feel was a city the size of New York but resembled Las Vegas. Note the custom buildings and attractions. <br><br>Tilt your device to pick up the four contestants and bring them to the audition at the Redshore Theater. 
     <br>
   
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/hUVru5pPxsU?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    
    <hr>
    <div class="paragraph">
        Responsibilities & Features :
        <ul>
        <li>Designed an entire city in Unity large enough to drive around in (Ferris Wheel included)</li>
        <li>Gameplay engineering</li>
        <li>LOD and camera occlusion</li>
        <li>Bus mesh polyreduction, UVs, and texturing</li>
        <li>Integration into larger core app</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/sing2_2.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/sing2_3.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/sing2_4.png" alt="Luca Bike Parts Hunt Screenshot" />
        <img class="pc-screenshot" src="img/projects/sing2_5.png" alt="Luca Bike Parts Hunt Screenshot" />
    </div>`, "#db7323", false, false),
  new ProjectData("project-1", "Rapid Prototyping | 3D | VFX", "img/projects/vr-cardiologist-sim-female.gif",
    `
    <div class="paragraph">
            <div class="hc-title">VR Operating Room - Quest 2 Experience</div>
            This prototype is for a local heart monitoring implant biotech partnering with the American College of Surgeons (ACS) to add immersive VR training to their offerings. This Quest 2 VR app features controller-less interaction using just your hands to utilize operating room tools.
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/s9CouHB1Vqo?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
            
           
                <hr>
  
                </div>

    <div class="paragraph">
    <div class="hc-title">Predator Camouflage VFX</div>

    Preview of a dissolve shader created in Shader Graph. Here, I am pressing the Space bar to toggle the Predator's camo on and off.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/9nINWcU9BdE?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <hr>
    
    <div class="paragraph">
    <div class="hc-title">VFX Switcher Prototype</div>

    This rapid prototype uses Maya, Mixamo, and C# to demonstrate a system to easily swap out VFX in Unity using Street Fighter's Ken and Elsa from Frozen.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/XSGLx8AbFvQ?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <hr>

    <div class="paragraph">
        <div class="hc-title">Virtual Car Dealership: PlayCanvas</div>
        I created this virtual car showroom in PlayCanvas. After stepping away from it for a while, I had forgotten just how powerful WebGL was. As for PlayCanvas, it's tantamount to using Unity in a browser, basically. It's even well-supported by VS Code.<br>
        
        <div class="paragraph center">
                <iframe class="youtube" src="https://www.youtube.com/embed/qdUh8PlTTUE?rel=0" frameborder="0" allowfullscreen></iframe>
            </div>
           
        </div>
    <hr>

    <div class="paragraph">
    <div class="hc-title">3D & VFX for Marvel Heros Space Race - Milano Ship</div>

    We tend to receive very highly-detailed, dense FBX and OBJ files when working with certain licensors on theatricals. In this case, someone at Disney/Marvel was ambitious enough to model every single minute item on Baby Groot's ship (the Milano), down to the very last rivet. It was awesome, quite frankly! Since that is not mobile-friendly, however, I had to perform some heavy poly reduction, retopo, UV unwrapping and general optimization in Photoshop and Maya before using in-game. I ended up breaking the ship into 5 separate textures to make it easier to work with.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/zs0csDoO0n4?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    
<div class="paragraph">
        Here's the final gameplay footage:
    </div>

    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/ywmRAYyeOAM?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <hr>
    
    <div class="paragraph">
    <div class="hc-title">Robot Defender Prototype</div>

    This rapid prototype was part of a take-home code submission for a AAA game studio a while back. The requirements stated the game must work with an XBox controller.

    Help Bumblebee defend Mission City!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/ZkR53-mfjgo?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Some technical aspects covered during development :
        <ul>
        <li>Xbox controller input</li>
        <li>Particle effects</li>
        <li>Object pooling</li>
        </ul>
    </div>

    <hr>
    <br>
    <div class="hc-title">VR Archery Training</div>
    <div class="paragraph">
    Ever wanted to live vicariously as Hawkeye? Now you can! 
    </br>
    </br>
    Strap on your Oculus/Quest 2 headset and grab your bow to practice your archery skills at the secret Avengers Training Facility! Say hi to Natasha while you're there.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/XPhFpF0X1MM?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>3D Modeling, UVs, and Texturing</li>
        <li>Building for Oculus Quest (OpenXR)</li>
        <li>Casting to Google Chrome</li>
        </ul>
    </div>
    <div class="paragraph">
      <div class="notice">
        Source code available on <a href="https://github.com/marvelasDev/VR_SecretTrainingHQ" target="_blank">GitHub</a>.
      </div>
    </div>
    <hr>
    <br>
    <div class="hc-title">Jenga</div>

     Here's a Jenga prototype using just 36 total lines of code. The intended eventual build target was for Oculus Quest.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/hQOGVu3PRuM?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>Procedural tower generation</li>
        <li>SOLID</li>
        <li>Building for Oculus Quest (OpenXR)</li>
        </ul>
    </div>
    
    <hr>
    <br>
    <div class="hc-title">Gstack Character Dialogue Tool</div>

     I developed this character dialogue controller for a company whose app teaches kids financial responsibility and budgeting via analog (e.g. chores) as well as digital tasks.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/93pG_a7iA70?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>Scriptable object templates to streamline character convos</li>
        <li>Persistent data using JSON to remember character names entered into Input Fields upon launch</li>
        <li>Typewriter effect for text</li>
        </ul>
    </div>
    <hr>
  
    </div>
    <div class="paragraph">
            <div class="hc-title">Beat Boxer: VR Rhythm Game</div>
            Whose VR portfolio would be complete without a Beat Saber-inspired prototype? 🙂<br>
            In this Quest 2 VR game, punch your way to fitness while listening to some great jams. Coming soon!
            
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/z9MC428nexc?rel=0" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>Scriptable objects to easily change out your song</li>
        <li>Oculus Integration SDK</li>
        <li>Cube spawn rate that corresponds to your chosen song's beats per minute (bpm)</li>
        <li>Custom post processing effects for VR using Global Volume on URP</li>
        </ul>
    </div>

    <hr>

    <div class="paragraph">
    <div class="hc-title">Just for Fun</div>

    My rendition of the zombie FPS from GameDevTV's older <a href="https://www.udemy.com/certificate/UC-ac159645-c891-4490-8f31-9afdb5820f8b" target="_blank"><strong>Complete Unity 3D Developer</strong></a> course. Never stop learning 💪🏼.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/mC-M-IJO3kE?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Some technical aspects covered during development :
        <ul>
        <li>Creating NPCs</li>
        <li>Terrain Editor</li>
        <li>ProBuilder Level Design</li>
        <li>Weapon switching</li>
        </ul>
    </div>

    <hr>

    
  
            

    <div class="paragraph">
    <div class="hc-title">Commercial Demo Reel (After Effects) </div>

    Congrats! You found this website's hidden Easter Egg. Did I mention I was an animator? (sarcasm). While a bit outdated, I leave this online because as with most people, my VFX career began with motion graphics. Talk about a time capsule, though.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://player.vimeo.com/video/90833100" frameborder="0" allowfullscreen></iframe>
    </div>

    `, "#08732f"),
  new ProjectData("project-1", "McPlay Happy Meal - Lego Batman", "img/projects/legobatman-icon.gif",
    `
    <div class="paragraph">
     This is <strong> The Lego Batman Movie</strong> iteration of <strong>McPlay</strong>, an extremely popular app for Happy Meal my team at Creata developed for McDonalds. McPlay housed addictive minigames created by our extremely talented team of artists, engineers, and producers, and was constantly updated with new content every Happy Meal.<br><br>
     Accolades :
        <ul>
        <li>Consistently ranked in the Top 10 Free apps for Kids 6-8 on Apple App Store</li>
        <li>Ranked #1 several dozen times</li>
        <li>Several hundred thousand daily active users</li>
        <li>Toy scanning feature to unlock content such as branded characters, powerups, and hidden levels</li>
        </ul>
    </div>
     
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/2csaQICkZ3U?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/appstorerank1.jpeg" alt="Mc Play App Store Screenshot" />
        <img class="phone-screenshot" src="img/projects/appstorerank5.jpeg" alt="Mc Play App Store Screenshot" />
        </div>
    <div class="paragraph">
        <strong>Note:</strong> McPlay was replaced by The Happy Meal App (which has unfortunately been discontinued).
    </div>

    <hr>
    <div class="paragraph">
        Responsibilities & Features :
        <ul>
        <li>Programmed dozens of individual games for numerous IPs and licenses</li>
        <li>Monthly updates to core app and interface</li>
        <li>Individual game programming for numerous IPs and licenses</li>
        <li>Training computervision classifiers for successful toy scanning</li>
        <li>Bug fixes</li>
        <li>Integrate games done by external dev shops</li>
        <li>Ensure a consistent experience across mobile phones and tablets</li>
        <li>QA build distribution via TestFlight, Appcenter, and Play Console</li>
        <li>Publish to App Store and Google Play</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/og_mcplay3.png" alt="Lego Batman Batarang Screenshot" />
        <img class="pc-screenshot" src="img/projects/og_mcplay4.png" alt="Lego Batman Batarang Screenshot" />
        <img class="pc-screenshot" src="img/projects/legobatman1.png" alt="Lego Batman Batwing Battle Test Screenshot" />
        <img class="pc-screenshot" src="img/projects/legobatman3.png" alt="Lego Batman Batwing Battle Test Screenshot" />
        <img class="pc-screenshot" src="img/projects/og_mcplay5.png" alt="Lego Batman Batwing Battle Test Screenshot" />
        </div>
    `, "#242424", false, true),
];